import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { CloudStoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { useCallback } from "react";
import { useSelector } from "react-redux";

import { StorePicker } from "@/components/Store/StorePicker/storePicker.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { getCart } from "@/redux/modules/api/data/cart/cart.selectors";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

import { SubmitChangeStore } from "./components/submitChangeStore/submitChangeStore.component";

type Props = {
    onChangeStore: (storeId: string) => void;
    stores: Array<string>;
    product: CartItem | null;
};

const ChangeStore = ({ onChangeStore, stores, product }: Props) => {
    const cart = useSelector(getCart);

    const { setExtendedActive, setActiveType } = useCallToActionsContext();

    const SubmitButton = useCallback(
        () => (
            <SubmitChangeStore
                product={product}
                onCancel={() => {
                    setActiveType(null);
                    setExtendedActive(false);
                }}
                onChangeStore={onChangeStore}
            />
        ),
        [product, onChangeStore, setActiveType, setExtendedActive]
    );

    return (
        <StorePicker
            sku={product?.sku ?? null}
            type={StorePickerType.CUSTOM}
            infoLink={null}
            storeCode={cart?.shopId ?? null}
            storeCodes={stores}
            displayStockLevel={!!product?.sku}
            fixedFeatures={[StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE]}
            SubmitComponent={SubmitButton}
            filterStoreType={CloudStoreType.WalkIn}
        />
    );
};

export default ChangeStore;
